export const adminMenu = [
    {
        activeAt: '/admin/campaigns',
        label: 'Campaigns',
        url: '/admin/campaigns',
    },
    {
        activeAt: '/admin/companies',
        label: 'Companies',
        url: '/admin/companies',
    },
    {
        activeAt: '/admin/users',
        label: 'Users',
        url: '/admin/users',
    },
];

export const dropdownMenu = [
    {
        activeAt: '/billing',
        label: 'Billing',
        url: '/billing',
    },
    {
        activeAt: '/settings',
        label: 'Settings',
        url: '/settings',
    },
    {
        activeAt: '/help',
        label: 'Help',
        url: '/help',
    },
    {
        activeAt: '/logout',
        label: 'Log out',
        url: '/logout',
    },
];

export const sellerMenu = [
    {
        activeAt: '/',
        label: 'Dashboard',
        url: '/',
    },
    {
        activeAt: '/campaigns',
        label: 'Campaigns',
        url: '/campaigns',
    },
    {
        activeAt: '/rank-insight',
        label: 'Tracking',
        url: '/rank-insight',
    },
    {
        activeAt: '/landing-pages',
        label: 'Landing Pages',
        url: '/landing-pages',
    },
    {
        activeAt: '/media',
        label: 'Video',
        url: '/media'
    },
    {
        activeAt: '/email-list',
        label: 'Emails',
        url: '/email-list',
    },
    {
        activeAt: '/rebates',
        isRenderedPath: ['company', 'canRebate'],
        label: 'Rebates',
        url: '/rebates',
    },
];

export const loggedOutMenu = [
    {
        activeAt: '/login',
        label: 'Login',
        url: '/login',
    },
    {
        activeAt: '/signup',
        label: 'Sign Up',
        url: 'https://business.snagshout.com/plan-picker',
    },
];



// WEBPACK FOOTER //
// ./src/constants/menuItems.js